import React, { useRef, ReactNode } from 'react';
import Icon from 'components/DesignSystem/Icon';
import './index.scss';
import Button from '../Button';

export const onSearchKeyDown = (
  setSearchQuery: (text: string) => void,
) => (
  (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setSearchQuery(event.currentTarget.value);
    }
  }
);

export const onClick = (
  inputRef: React.RefObject<HTMLInputElement | null>,
  setSearchQuery: (text: string) => void,
  onChange: React.ChangeEventHandler<HTMLInputElement>,
) => () => {
  inputRef.current?.setRangeText('', 0, -1);
  setSearchQuery('');
  // O evento é fabricado (não há interação real com o input), então precisa expor os dois
  // campos que um React.ChangeEvent de verdade traz: consumidores usam ambos — `onTextChange`
  // (helper/controlledField, usado por 6 telas com Searcher) lê `currentTarget`, enquanto as
  // telas de Agro/Fields leem `target`. Só com `target` o clique no X estourava
  // "Cannot read properties of undefined (reading 'value')" em /admin/companies.
  onChange({
    target: { value: '' },
    currentTarget: { value: '' },
  } as React.ChangeEvent<HTMLInputElement>);
};

export default function Searcher({
  value,
  onChange,
  results = [],
  placeholder = '',
  disabled = false,
  id = undefined,
  className = '',
  setSearchQuery = () => { },
  list = '',
}: {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  results?: ReactNode[];
  placeholder?: string;
  disabled?: boolean;
  id?: string | undefined;
  className?: string;
  setSearchQuery?: (text: string) => void;
  list?: string;
}) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className={`ds-searcher-container ${className}`}>
      <div className={`ds-searcher-bar ${disabled ? 'ds-searcher-bar-disabled' : ''}`}>
        <Icon iconType="search" />
        <input
          ref={inputRef}
          id={id}
          className="ds-searcher-input"
          type="search"
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={onSearchKeyDown(setSearchQuery)}
          list={list}
        />
        {value && (
          <Button
            className="ds-searcher-clear-button"
            icon="close"
            onClick={onClick(inputRef, setSearchQuery, onChange)}
          />
        )}
      </div>
      <div className={`ds-searcher-results ${results.length && !disabled ? '' : 'ds-searcher-results-hidden'}`}>
        <ul>
          <li>
            <div className="ds-searcher-results-count">
              {`${results.length} RESULTADO${results.length === 1 ? '' : 'S'}`}
            </div>
          </li>
          {results.map((result, index) => (
            <li key={`result-${index + 1}`}>
              {result}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
